import { Component, OnInit, OnDestroy } from '@angular/core';
import { FaqItem } from '../../models/faq-item';
import { EbookFaqService } from '../../services/ebook-faq/ebook-faq.service';
import { SubscriptionsRemovingComponent } from '../../../shared/components/subscription-removing/subscription-removing.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url/safe-url.pipe';


@Component({
    selector: 'ebook-faq',
    templateUrl: './ebook-faq.component.html',
    styleUrls: ['./ebook-faq.component.scss'],
    providers: [EbookFaqService],
    standalone: true,
    imports:[CommonModule, FormsModule, SafeUrlPipe]
})
export class EbookFaqComponent extends SubscriptionsRemovingComponent implements OnInit, OnDestroy {

  public faqs: Array<FaqItem>;
  public tutorialUrl: string;

  constructor(private faqService: EbookFaqService) {
    super();
  }

  ngOnInit() {
    super.addSubscription(this.faqService.getFAQs().subscribe(items => {
      this.faqs = items;
    }));

    super.addSubscription(this.faqService.getTutorialURL().subscribe(url => {
      this.tutorialUrl = url;
    }));
  }

  ngOnDestroy(): void {
    super.clearSubscriptions();
  }

}
